import React, { useState } from "react";
import { GetAccess } from "../../../utils/RolesandAccess";
import { AddIcon, LoadingImgIcon } from "../../../assets/icons";
import EditIcon from "../../../assets/icons/EditIcon";
import UseGetData from "../../../hooks/useFetchData";
import CreateorUpdate from "./form";
import { ViewLabelwithData } from "../../../components/View/ViewLabelwithData";
import { ViewLabelwithDataLoader } from "../../../components/Loader";

function CompanyInfoIndex() {
  const { data, getData, isLoading } = UseGetData({ url: "/company-info/" });
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  return (
    <>
      <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
        <div className="pb-2 px-2 flex justify-between items-center w-full">
          <h4 className="text-sm 2xl:text-base font-medium text-heading">
            Company Info
          </h4>
          <div className=" w-8 flex justify-center items-center cursor-pointer">
            {GetAccess("admin_create") && (
              <div onClick={() => setShowMyModal(true)}>
                {data.length > 0 ? (
                  <div className=" w-7 h-7 bg-primary rounded flex justify-center items-center">
                    <EditIcon />
                  </div>
                ) : (
                  <AddIcon />
                )}
              </div>
            )}
          </div>
        </div>
        <div className=" w-full h-[calc(100vh-185px)] px-2  flex">
          <div className=" mx-auto  px-4">
            <div className=" w-[20rem] h-[20rem] rounded-md border-[2px]  flex justify-center items-center border-primary overflow-hidden shadow-box bg-slate-200 ">
            {isLoading == true ? (<LoadingImgIcon height="h-24" width="w-24"  color="text-gray-100"/>):(<>
              {data[0]?.companyLogo && (
                <img src={data[0]?.companyLogo} alt="#" width="100%" />
              )}
            </>)}

            </div>
          </div>
          <div className="  px-4 flex-1 space-y-6">
            {isLoading == true ? (
              <>
                {[...Array(7)].map((_, index) => {
                  return <ViewLabelwithDataLoader key={index} />;
                })}
              </>
            ) : (
              <>
                <ViewLabelwithData
                  title="Company Name"
                  value={data[0]?.companyName || "-"}
                />
                <ViewLabelwithData
                  title="Address"
                  value={data[0]?.address || "-"}
                />
                <ViewLabelwithData title="City" value={data[0]?.city || "-"} />
                <ViewLabelwithData
                  title="Country"
                  value={data[0]?.country || "-"}
                />
                <ViewLabelwithData
                  title="Website"
                  value={data[0]?.companyWebsite || "-"}
                />
                <ViewLabelwithData
                  title="Email"
                  value={data[0]?.email || "-"}
                />
                <ViewLabelwithData
                  title="Phone No"
                  value={data[0]?.mobile || "-"}
                />
              </>
            )}
          </div>
        </div>
      </div>

      {data?.length > 0 ? (
        <CreateorUpdate
          data={data[0]}
          onClose={handleOnClose}
          visible={showMyModal}
          refreshData={getData}
          id={data[0]?.id}
        />
      ) : (
        <CreateorUpdate
          onClose={handleOnClose}
          visible={showMyModal}
          refreshData={getData}
          id={data[0]?.id}
        />
      )}
    </>
  );
}

export default CompanyInfoIndex;
